import {negate} from 'ramda';

export type PercentageSwitchInputs = {
  originalValue: string;
  discountValue: string;
  signDiscountValue: (apiDiscountValue: string) => string;
};

// Prepares inputs for the calculatePercentage API when switching a discount
// item's unit from "ks" back to "%". Both API inputs are magnitudes (Math.abs)
// so the API never sees a negative denominator — this matters in corrective
// tax documents where mapInvoiceItems inverts the signs of original-item prices.
// signDiscountValue mirrors the sign of pricePerUnit at the moment of the
// switch, which preserves the document's sign convention (negative for regular
// invoices, positive for CTDs) across the % → ks → % roundtrip.
export const buildPercentageSwitchInputs = (
  rawOriginalValue: string,
  rawPricePerUnit: string
): PercentageSwitchInputs => {
  const pricePerUnit = parseFloat(rawPricePerUnit);
  return {
    originalValue: Math.abs(parseFloat(rawOriginalValue)).toString(),
    discountValue: Math.abs(pricePerUnit).toString(),
    signDiscountValue: (apiDiscountValue) =>
      pricePerUnit < 0 ? negate(parseFloat(apiDiscountValue)).toString() : apiDiscountValue,
  };
};
